<template>
    <client-page class="wrap--join">
        <!-- 메인 -->
        <main class="main" role="main">
            <div class="inner">
                <h2 class="join-title">회원가입</h2>

                <div class="join-container">
                    <div class="join-gate">
                        <!-- 개인 -->
                        <div class="join-gate-box join-gate-box--personal">
                            <div class="join-gate-box__inner">
                                <i class="icon icon-general"></i>
                                <h2>일반회원 가입</h2>
                                <!-- <p>자문단 및 인력양성사업 참여학생</p> -->
                                <v-btn @click="submit(USER_TYPES.INDIVIDUAL)" rounded color="primary" elevation="0" class="mt-30 min-w-120px min-w-lg-140px">가입하기</v-btn>
                                <!-- <button @click="submit(USER_TYPES.INDIVIDUAL)" class="button button--primary min-w150 min-md-wauto">
                                    가입하기
                                </button> -->
                            </div>
                        </div>
                        <!-- 업체 -->
                        <div class="join-gate-box join-gate-box--business">
                            <div class="join-gate-box__inner">
                                <i class="icon icon-business"></i>
                                <h2>기업회원 가입</h2>
                                <!-- <p>일반기업 및 e이음 · e바꿈 참여기업</p> -->
                                <v-btn @click="submit(USER_TYPES.ORGANIZATION)" rounded color="primary" elevation="0" class="mt-30 min-w-120px min-w-lg-140px">가입하기</v-btn>
                                <!-- <button @click="submit(USER_TYPES.ORGANIZATION)" class="button button--primary min-w150 min-md-wauto">
                                    가입하기
                                </button> -->
                            </div>
                        </div>
                    </div>

                    <!-- 하단버튼 -->
                    <!-- <div class="bottom-button">
                        <a class="button button--border-primary" href="" onclick="return false;" @click="$router.go(-1)"><span>취소하기</span></a>
                        <a class="button button--primary" @click="submit"><span>계속 진행</span></a>
                    </div> -->
                </div>
            </div>
        </main>
    </client-page>
</template>

<script>
import { USER_TYPES } from "@/assets/variables";

import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
    components: {
		ClientPage,
    },
    data() {
        return { USER_TYPES };
    },
    methods: {
        submit(code) {
            this.$router.push(`/join?code=${code}`);
        },
    },
};
</script>

<style scoped>
table, table tr th, table tr td{
    border: 1px solid #ddd;
}
table tr th, table tr td{
    border: 1px solid #ddd;
}
p{
    line-height: 1.6;
}
</style>
